export class TicketApi {
    constructor(client) {
        this.client = client;
    }

    async getTicket(id) {
        const ticket = await this.client.get('/api/SupportTickets/' + id, {
            anonymous: true
        });

        return{
            ticket
        };
    }

    async createTicket(data){
        const response = await this.client.post('/api/SupportTickets', data);
        return response;
    }

}